module.exports = __webpack_public_path__ + "files/b8edeef2e8f1f5afa5e7c1e91f6a259b.png";


//////////////////
// WEBPACK FOOTER
// ./images/icon50x50.png
// module id = 498
// module chunks = 76